import { render, staticRenderFns } from "./MultipleChoicePreview.vue?vue&type=template&id=183ca520&"
import script from "./MultipleChoicePreview.vue?vue&type=script&lang=js&"
export * from "./MultipleChoicePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports